import { apiAuth } from "./Configs/AxiosConfigs"

export const DashboardApi = {

    getData: async function () {
        const response = await apiAuth.request({
          url: "/dashboard/",
          method: "GET",
        })  
        return response.data;
      }
 
}
